import React, {Component} from 'react';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {Spinner} from "../Spinner";
import {SubmitButton} from "../buttons/SubmitButton";
import {MultiSelect} from "../selects/MultiSelect";
import {LinkToSection} from "../elements/LinkToSection";
import {LocalStorage} from "../../utils/LocalStorage";
import { withTranslation } from 'react-i18next';
import {ReadOnlyMultiSelect} from "../selects/ReadOnlyMultiSelect";


class UserModuleMarketingInfoClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            savingChanges: false,
            userModuleMarketingInfo: null,
            loggedUserCanAssignClients: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClientsChange = this.handleClientsChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    userModuleMarketingDataURL() {
        return API_URL + 'user/' + this.props.userId + '/module/marketing';
    }

    setIsSaving(new_value){
        this.setState({
            ...this.state,
            'savingChanges': new_value
        });
    }

    editingLoggedUser() {
        return this.props.userId === LocalStorage.fetchUserId();
    }

    getUserModuleMarketingData() {
        this.setIsSaving(true);
        new APIClient(this.userModuleMarketingDataURL()).call('GET').then((response) => {
            this.setIsSaving(false);
            if (response.status === 'ERROR') {
                alert(response['error_message']);
            } else if (response.status === 'OK') {
                this.setState({
                    userModuleMarketingInfo: {
                        'clients': response.data.clients,
                        'selectedClients': response.data.selected_clients
                    },
                    loggedUserCanAssignClients: response.data.user_doing_operation_can_assign_clients,
                    loggedUserCanCreateClients: response.data.user_doing_operation_can_create_clients
                });
            }
        })
    }

    handleClientsChange(selectedClients) {
        this.setState({
            userModuleMarketingInfo: {
                ...this.state.userModuleMarketingInfo,
                selectedClients: selectedClients
            }
        });
    }


    componentDidMount() {
        this.getUserModuleMarketingData();
    }

    handleSubmit() {
        this.setState({savingChanges: true});
        new APIClient(this.userModuleMarketingDataURL()).call('POST', {
            'clients': this.state.userModuleMarketingInfo.selectedClients
        }).then((data) => {
            this.setState({savingChanges: false});
            let errors = [];
            if (data.status === 'ERROR') {
                errors = JSON.parse(data.errors);
            } else if (data.status === 'OK') {
                this.props.afterSuccessfulSubmit();
            }
            this.setState({
                userModuleMarketingInfo: {
                    ...this.state.userModuleMarketingInfo,
                    errors: errors
                }
            });
        });
    }

    renderClientsSelect() {
        const { t } = this.props;
        if (this.state.userModuleMarketingInfo !== null) {
            if (!this.state.loggedUserCanAssignClients) {
                const allClients = this.state.userModuleMarketingInfo.clients;
                const selectedClientIds = this.state.userModuleMarketingInfo.selectedClients.map(id => id.toString());
                const selectedClients = allClients.filter(client => selectedClientIds.includes(client.id.toString()));

                return (
                    <ReadOnlyMultiSelect
                        items={selectedClients}
                    />
                );
            }
            return (
                <MultiSelect
                    showOnlyActiveCheck={true}
                    items={this.state.userModuleMarketingInfo.clients}
                    selectedItemIds={this.state.userModuleMarketingInfo.selectedClients}
                    onChange={this.handleClientsChange}
                />
            );
        } else {
            return <p>{t('user_marketing.loading')}</p>
        }
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const value = target.value;

        this.setState({
            userModuleMarketingInfo: {
                ...this.state.userModuleMarketingInfo,
                [name]: value
            }
        });
    }

    renderSaveButton() {
        const { t } = this.props;
        if(!this.state.loggedUserCanAssignClients)
            return

        if (this.state.savingChanges) {
            return <Spinner color="positive small"/>;
        } else {
            return <SubmitButton onClick={this.handleSubmit} value={t('user_marketing.save_button')}/>;
        }
    }

    getClientHeaderText() {
        const { t } = this.props;
        return t('user_marketing.assigned_clients');
        //return this.editingLoggedUser() ? "Clientes asignados" : "Clientes";
    }

    renderModuleMarketingInfo() {
        const { t } = this.props;
        const createClientText = this.state.loggedUserCanCreateClients ? <span> {t('user_marketing.create_client_text')} <LinkToSection url={"/agency/clients"} text={t('user_marketing.create_client_link')} /></span> : null;
        const boxLabel = this.state.loggedUserCanAssignClients ? [t('user_marketing.select_clients'), createClientText] : t('user_marketing.assigned_clients');

        if (this.state.userModuleMarketingInfo !== null) {
            return (
                <div className="box">
                    <header className="box-header">
                        <h2 className="box-title">{this.getClientHeaderText()}</h2>
                    </header>
                    <div className="form-row">
                        <label>{boxLabel}</label>
                        {this.renderClientsSelect()}
                    </div>
                </div>
            )
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    render() {
        return (
            <form className="section-body-item -wide">
                {this.renderModuleMarketingInfo()}
                <div className="submit-row">
                    {this.renderSaveButton()}
                </div>
            </form>
        )
    }
}

export const UserModuleMarketingInfo = withTranslation()(UserModuleMarketingInfoClass);